exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._automation-details{min-height:100%}._automation-details .car-image{height:250px;background-repeat:no-repeat;background-position:50%;background-size:cover}._automation-details .green-icon{color:#44c782}._automation-details .custom-layout{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/installerDetails/installerDetails.styl
// module id = 465
// module chunks = 0